/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const StringClaimValue: core.serialization.ObjectSchema<
    serializers.StringClaimValue.Raw,
    Truvity.StringClaimValue
> = core.serialization.object({
    value: core.serialization.string(),
});

export declare namespace StringClaimValue {
    export interface Raw {
        value: string;
    }
}
